var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 441,
    height: 207.437,
    viewBox: "0 0 441 207.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f7c1a011-b3c2-48ad-810f-5b42329b7511",
    transform: "translate(0.014 0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M289.673,42.385,434.433.069a6.781,6.781,0,0,1,8.5,4.7l25.136,85.988a6.781,6.781,0,0,1-4.7,8.5l-144.76,42.316a6.781,6.781,0,0,1-8.5-4.7L284.972,50.884A6.872,6.872,0,0,1,289.673,42.385Z",
    transform: "translate(-27.371 0.2)",
    fill: "#f5ecce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M347.4,101.159l95.753-30.381a3.888,3.888,0,0,1,4.973,2.622h0a3.888,3.888,0,0,1-2.622,4.973l-95.753,30.471a3.888,3.888,0,0,1-4.973-2.622h0a3.978,3.978,0,0,1,2.622-5.063Z",
    transform: "translate(-33.108 -6.584)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M373.816,112.5,432.678,93.78a3.8,3.8,0,0,1,4.792,2.441h0a3.8,3.8,0,0,1-2.441,4.792L376.167,119.73a3.8,3.8,0,0,1-4.792-2.441h0a3.617,3.617,0,0,1,2.441-4.792Z",
    transform: "translate(-35.653 -8.789)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M23.336,86.789l148.648,25.679a6.872,6.872,0,0,1,5.606,7.957l-15.281,88.248a6.872,6.872,0,0,1-7.957,5.606L5.8,188.6a6.872,6.872,0,0,1-5.606-7.957L15.379,92.4a6.872,6.872,0,0,1,7.957-5.606Z",
    transform: "translate(-0.1 -8.127)",
    fill: "#e6f1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M32.6,160.994l99.008,16.727a3.978,3.978,0,0,1,3.255,4.611h0a3.978,3.978,0,0,1-4.611,3.255L31.249,168.951a3.978,3.978,0,0,1-3.255-4.611h0a3.978,3.978,0,0,1,4.611-3.345Z",
    transform: "translate(-2.768 -15.242)",
    fill: "#a7af94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M51.435,182.093,112.286,192.4a3.8,3.8,0,0,1,3.074,4.34h0a3.8,3.8,0,0,1-4.34,3.074L50.169,189.508a3.8,3.8,0,0,1-3.074-4.34h0a3.707,3.707,0,0,1,4.34-3.074Z",
    transform: "translate(-4.6 -17.263)",
    fill: "#a7af94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M118.443,53.2H357.6a7.143,7.143,0,0,1,7.143,7.143v144.85a7.143,7.143,0,0,1-7.143,7.143H118.443a7.143,7.143,0,0,1-7.143-7.143V60.343A7.143,7.143,0,0,1,118.443,53.2Z",
    transform: "translate(-10.756 -4.919)",
    fill: "#e5f2fd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 2.984,
    cy: 2.984,
    r: 2.984,
    transform: "translate(107.054 59.765)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 2.984,
    cy: 2.984,
    r: 2.984,
    transform: "translate(116.638 59.765)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 2.984,
    cy: 2.984,
    r: 2.984,
    transform: "translate(126.403 59.765)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M209.6,112.3a6.51,6.51,0,1,1,6.42,6.42,6.42,6.42,0,0,1-6.42-6.42Z",
    transform: "translate(-20.175 -9.949)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M279,112.32a6.42,6.42,0,1,1,6.42,6.42,6.42,6.42,0,0,1-6.42-6.42Z",
    transform: "translate(-26.825 -9.968)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M361.9,62h.09",
    transform: "translate(-34.768 -5.762)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M361.4,62h0",
    transform: "translate(-34.72 -5.762)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M362.111,66.037a3.707,3.707,0,0,1-2.8,1.266h-.723l-.452-.543h0V66.58a4.34,4.34,0,0,1-.633-2.08,2.08,2.08,0,0,0,2.532,1.356h0l.452-.271h0a1.537,1.537,0,0,1,1.628.452Z",
    transform: "translate(-34.347 -6.001)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M361.8,61.9Z",
    transform: "translate(-34.759 -5.752)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M354.181,62.8H354",
    transform: "translate(-34.011 -5.838)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M352.081,64.181,351.9,64",
    transform: "translate(-33.81 -5.953)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M355.071,67.271,354.8,67",
    transform: "translate(-34.088 -6.241)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M357.337,66.6l1.085.362-.452-.543V66.24a4.34,4.34,0,0,1-.633-2.08,1.9,1.9,0,0,1,.9-2.26l-.723.271-.9.633a2.713,2.713,0,0,1-.814,1.175,2.441,2.441,0,0,0,.452,1.356Z",
    transform: "translate(-34.184 -5.752)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M355.463,61.9a3.256,3.256,0,0,1-.181.9,1.809,1.809,0,0,0-.362-.723,1.628,1.628,0,0,0-1.356-.633h-2.17A1.718,1.718,0,0,1,350.4,60h2.984a2.08,2.08,0,0,1,2.08,2.08Z",
    transform: "translate(-33.666 -5.57)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M356.273,66.5a1.266,1.266,0,0,1-1.808.271h-.09l-.271-.181-2.441-2.622-.181-.181h0a.452.452,0,0,1,0-.723l.181-.181h1.9l.452-.452h0a.543.543,0,0,0-.362-.633,1.628,1.628,0,0,1,1.356.633,1.809,1.809,0,0,1,.362.723,2.351,2.351,0,0,1-1.447,1.175l.543.543Z",
    transform: "translate(-33.752 -5.742)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M351.123,65.1h0c.362-.09.723.271.814.633h0v.814a.814.814,0,0,1-.814.723h0a.814.814,0,0,1-.723-.723v-.814A.814.814,0,0,1,351.123,65.1Z",
    transform: "translate(-33.666 -6.057)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M362.3,62.9v.452h-.09c-.181,0-.362.271-.362.452v.723H361.4V62.99h.452v.271C361.852,63.081,362.123,62.9,362.3,62.9Z",
    transform: "translate(-34.72 -5.848)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M364.1,63.806h-1.085c0,.181.181.271.362.271h.362l.271.181a.814.814,0,0,1-.633.271.831.831,0,0,1-.633-1.537.542.542,0,0,1,.543,0,.723.723,0,0,1,.814.633v.181Zm-1.175-.271h.723c0-.181-.181-.271-.362-.271S363.017,63.354,362.926,63.535Z",
    transform: "translate(-34.8 -5.85)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M366.128,62.9v1.266a.723.723,0,0,1-.633.814h-.181l-.723-.181.181-.362.452.181c.362,0,.452-.09.452-.362h0l-.452.181a.723.723,0,0,1,0-1.447h0a.452.452,0,0,1,.452.271V62.99Zm-.452.723a.362.362,0,1,0-.362.362h0A.362.362,0,0,0,365.675,63.623Z",
    transform: "translate(-35.017 -5.848)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M368.147,62.9v1.537h-.362v-.181l-.452.181c-.271.09-.543-.181-.633-.452V62.9h.452v.814c0,.271.09.362.271.362s.362-.271.362-.452V62.9Z",
    transform: "translate(-35.228 -5.848)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M368.8,62.3h.452v2.08H368.8Z",
    transform: "translate(-35.429 -5.79)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M370.956,63.533v.9h-.362v-.181l-.452.181c-.362,0-.543-.181-.543-.452s.181-.452.633-.452h.362c0-.181-.181-.271-.362-.271h-.452v-.181l.543-.181A.633.633,0,0,1,370.956,63.533Zm-.362.452V63.8h-.362c-.181,0-.271.09-.271.181s.091.181.271.181Z",
    transform: "translate(-35.506 -5.848)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M372.485,64.308h-.362c-.271.09-.452-.09-.542-.362v-.814H371.4v-.271h.181V62.5h.452v.362h.362v.271h-.362v.633l.181.181h.181Z",
    transform: "translate(-35.678 -5.81)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M372.8,62.471a.271.271,0,0,1,.271-.271c.181,0,.271.09.271.181a.271.271,0,0,1-.271.271C372.89,62.652,372.8,62.562,372.8,62.471Zm.09.362h.362V64.37h-.362Z",
    transform: "translate(-35.813 -5.781)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M373.7,63.714a.723.723,0,0,1,.633-.814h.181a.814.814,0,0,1,.723.723h0a.814.814,0,0,1-.723.723c-.362.09-.723-.271-.814-.633Zm1.175,0c0-.181-.181-.452-.362-.452a.452.452,0,0,0-.452.452c0,.181.271.362.452.362A.362.362,0,0,0,374.875,63.714Z",
    transform: "translate(-35.898 -5.848)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M377.247,63.531v.9h-.452v-.814c0-.271-.09-.362-.271-.362s-.362.271-.362.452v.723H375.8V62.9h.362v.181l.452-.181c.271-.09.543.181.633.452Z",
    transform: "translate(-36.1 -5.846)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M377.7,63.7a.814.814,0,0,1,.723-.9,1,1,0,0,1,.814.452l-.362.181a.452.452,0,0,0-.362-.181c-.181,0-.362.271-.362.452a.362.362,0,0,0,.362.362l.362-.181.362.181A.85.85,0,0,1,377.7,63.7Z",
    transform: "translate(-36.281 -5.838)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M379.6,62.471a.271.271,0,0,1,.271-.271c.181,0,.271.09.271.181a.271.271,0,0,1-.271.271h0C379.69,62.652,379.6,62.562,379.6,62.471Zm0,.362h.452V64.37H379.6Z",
    transform: "translate(-36.464 -5.781)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M381.485,64.308h-.362c-.271.09-.452-.09-.543-.362v-.814H380.4v-.271h.181V62.5h.452v.362h.362v.271h-.362v.633l.181.181h.181Z",
    transform: "translate(-36.541 -5.81)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M383.228,62.89l-.633,1.628a.542.542,0,0,1-.633.452h0l-.362-.181.181-.271h.181c.181,0,.181-.09.271-.181h0L381.6,62.8h.452l.362.995.452-.995Z",
    transform: "translate(-36.656 -5.838)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M359.213,59.9h-.181a3.8,3.8,0,0,0-2.532,1.266,2.623,2.623,0,0,1,.181.814h0a1.175,1.175,0,0,1-.09.543l.9-.543.633-.271a1.808,1.808,0,0,1,1.537-.181l.543.181h.542a1.808,1.808,0,0,0,1.266-.543,3.707,3.707,0,0,0-2.8-1.266Z",
    transform: "translate(-34.251 -5.561)",
    fill: "#91aec1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M432.3,13.5h.181",
    transform: "translate(-41.514 -1.115)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M431.8,13.7h0",
    transform: "translate(-41.466 -1.134)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M433.683,17.272a3.346,3.346,0,0,1-2.17,2.08H430.7l-.542-.452h-.181a4.158,4.158,0,0,1-1.175-1.808,1.989,1.989,0,0,0,2.8.452h0l.362-.271h0A1.537,1.537,0,0,1,433.683,17.272Z",
    transform: "translate(-41.178 -1.451)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M432.2,13.5Z",
    transform: "translate(-41.504 -1.115)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M425.2,16.6h0",
    transform: "translate(-40.833 -1.412)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M423.581,18.581c-.09-.09-.181-.09-.181-.181",
    transform: "translate(-40.661 -1.584)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M427.371,20.6H427.1",
    transform: "translate(-41.015 -1.795)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M429.451,19.2h1.085l-.542-.452h-.181a4.159,4.159,0,0,1-1.175-1.808,2.17,2.17,0,0,1,.09-2.441l-.543.452-.633.814a2.712,2.712,0,0,1-.452,1.447,2.894,2.894,0,0,0,.9,1.175Z",
    transform: "translate(-41.015 -1.21)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M426.225,15.346a1.266,1.266,0,0,1,.09.814,1.538,1.538,0,0,0-.543-.543,1.628,1.628,0,0,0-1.447-.181h-.271l-1.447.452h-.452a1.718,1.718,0,0,1-1.356-.995l2.8-.9a2.08,2.08,0,0,1,2.622,1.356Z",
    transform: "translate(-40.412 -1.152)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M428.5,19.5a1.447,1.447,0,0,1-1.808.814h0l-.271-.181-3.165-1.718h-.181a.723.723,0,0,1-.181-.9h.09l.271-.181,1.447-.452h0a.814.814,0,0,0,.271-.543h0a.542.542,0,0,0-.452-.543,1.627,1.627,0,0,1,1.447.181,1.537,1.537,0,0,1,.543.543,2.079,2.079,0,0,1-.995,1.628l.723.362Z",
    transform: "translate(-40.604 -1.325)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M423.139,19.7h0a.723.723,0,0,1,.9.543h0l.271.723a.723.723,0,0,1-.543.9h0a.633.633,0,0,1-.814-.271c0-.09,0-.09-.09-.181l-.271-.723a.814.814,0,0,1,.542-.995Z",
    transform: "translate(-40.581 -1.706)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M433,14.2l.181.452h-.09a.362.362,0,0,0-.362.362v.181l.181.633h-.362l-.452-1.356.362-.181v.181Z",
    transform: "translate(-41.495 -1.182)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M435.037,14.543l-1.085.362c.09.181.271.181.542.181l.271-.271.271.181a.9.9,0,0,1-.452.362A.814.814,0,0,1,433.5,14.9h0a.814.814,0,0,1,.723-.9,1,1,0,0,1,.814.452Zm-1.175.09.723-.181a.362.362,0,0,0-.452-.181C433.952,14.271,433.861,14.452,433.861,14.633Z",
    transform: "translate(-41.628 -1.162)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M436.644,13.1l.362,1.175c.181.543,0,.814-.543.995h-.723V15h.543a.362.362,0,0,0,.362-.362c0-.09,0-.09-.09-.181h0a.9.9,0,0,1-.452.362.814.814,0,0,1-.9-.452.723.723,0,0,1,.542-.9h0c.181-.09.362-.09.452.09v-.181Zm-.181.814a.452.452,0,0,0-.452-.271c-.271.09-.362.271-.271.452s.271.362.452.271.362-.271.271-.452Z",
    transform: "translate(-41.789 -1.076)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M438.647,12.5l.452,1.356-.452.181v-.181a.63.63,0,0,1-1.175,0h0l-.271-.814.452-.181.181.814a.362.362,0,0,0,.452.181c.181,0,.271-.181.181-.452l-.271-.723Z",
    transform: "translate(-41.983 -1.019)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M439,11.781l.452-.181.542,1.989h-.362Z",
    transform: "translate(-42.156 -0.933)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M441.547,12.262l.181.814h-.362l-.452.271a.633.633,0,0,1-.633-.181h0c-.09-.181.09-.452.452-.543l.362-.181c-.09-.181-.181-.181-.452-.181l-.362.271-.181-.181a.723.723,0,0,1,.543-.362.543.543,0,0,1,.814.271.09.09,0,0,1,.09,0Zm-.362.543v-.181h-.271c-.181.09-.271.181-.181.271H441C441.095,12.985,441.185,12.894,441.185,12.8Z",
    transform: "translate(-42.261 -0.961)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M443.156,12.528l-.271.181c-.362.09-.633,0-.723-.362l-.181-.543H441.8v-.362h.181v-.362l.362-.181.181.362h.271l.181.271-.362.181.181.543c0,.09.09.181.181.09h.181Z",
    transform: "translate(-42.424 -0.865)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M442.9,10.671c0-.09,0-.271.181-.271h.362l-.181.362C443.081,10.852,442.9,10.762,442.9,10.671Zm.181.362h.452l.362,1.356-.362.181Z",
    transform: "translate(-42.529 -0.818)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M444.1,11.592a.814.814,0,0,1,.543-.995.9.9,0,0,1,.995.452.814.814,0,0,1-.542.995.723.723,0,0,1-.995-.362Zm1.085-.362c0-.181,0-.271-.181-.362h-.271a.362.362,0,0,0-.181.452c0,.181,0,.271.181.362H445c.181,0,.271-.181.181-.452Z",
    transform: "translate(-42.641 -0.834)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M447.437,10.343l.271.814-.362.181-.271-.723c-.09-.271-.181-.362-.362-.271s-.271.181-.181.452l.181.723h-.452l-.362-1.356.362-.181v.181a.872.872,0,0,1,1.085-.181.542.542,0,0,1,.09.362Z",
    transform: "translate(-42.817 -0.76)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M447.992,10.392a.633.633,0,0,1,.362-.9h.181a.452.452,0,0,1,.723.181l-.271.271c-.09-.09-.181-.181-.362-.09a.452.452,0,0,0-.271.452.362.362,0,0,0,.362.362h.181l.271-.271h.362a.723.723,0,0,1-.995.543.633.633,0,0,1-.542-.362Z",
    transform: "translate(-43.01 -0.719)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M449.4,8.658c-.09-.181,0-.271.181-.362s.271,0,.271.181,0,.271-.181.271h0C449.577,8.839,449.487,8.748,449.4,8.658Zm.181.362h.362l.452,1.356-.452.181Z",
    transform: "translate(-43.148 -0.613)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M451.756,9.828l-.271.181c-.362.09-.633,0-.723-.362l-.181-.543H450.4V8.743h.181V8.381l.362-.181v.362h.362v.271l-.362.181.181.543c.09.09.181.181.271.09h.181Z",
    transform: "translate(-43.248 -0.607)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M453.018,8l-.181,1.628c0,.452-.181.543-.452.633h-.452V9.9h.271l.181-.271h0L451.3,8.362h.452l.723.814V8.09Z",
    transform: "translate(-43.334 -0.588)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M429.17,12.281h-.181A3.616,3.616,0,0,0,427,14.27a1.085,1.085,0,0,1,.362.723h0a1.174,1.174,0,0,1,.09.543l.723-.814.542-.452a2.17,2.17,0,0,1,1.447-.633h1.085a1.628,1.628,0,0,0,.995-.9,3.436,3.436,0,0,0-3.074-.452Z",
    transform: "translate(-41.006 -0.981)",
    fill: "#bcb093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M201.9,185.123a63.564,63.564,0,0,1,89.966,0",
    transform: "translate(-19.437 -15.772)",
    fill: "none",
    stroke: "#91aec1",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.63cb17ea912879f419a90c29c0f27fad.svg";
export { ForwardRef as ReactComponent };